import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    seatDetailUrl: String,
    isAdminUser: Boolean,
    totalseats: Number,
    bustype: String,
    fare: Number,
    businessfare: Number,
    buswithhostess: String,
    busleftseats: Number,
    busrightseats: Number,
    busseats: Array,
    // ["12M", "14F", …]: genders of the seats other bookings already hold.
    bookedgenders: Array,
    // Seat numbers held by unpaid Cash on Counter bookings (admin panel only), coloured apart.
    counterseats: Array
  }

  static targets = [
    'customerDetails', 'customerName', 'customerCnic',
    'customerPhone', 'customerSeatNo', 'customerAmount', 'seatNotice'
  ]

  connect() {
    this.initSeatChart()
  }

  initSeatChart() {
    this.customerDetailsVisibility(false);
    let cart = $('#selected-seats')
    let counter = $('#counter')
    let total = $('#total')
    let self = this
    let [seatsMapping, unavailableSeats] = this.busseatsValue
    let mapping = this.busSeatsMapping(seatsMapping)
    let seatNumbers = seatsMapping
    this.seatNeighbours = this.buildSeatNeighbours(seatsMapping)
    let sc = $('#seat-map').seatCharts({
      map: mapping,
      seats: {
        l: {
            price   : parseFloat(this.fareValue),
            description : 'Luxury Seat Price',
            classes : 'first-class', //your custom CSS class
            category: 'First Class'
          },
        e: {
          price   : parseFloat(this.fareValue),
          description : 'Economical Seat Price',
          classes : 'economy-class', //your custom CSS class
          category: 'Economy Class'
        },
        b: {
          price   : parseFloat(this.businessfareValue),
          description : 'Luxury Seat Price',
          classes : 'first-class', //your custom CSS class
          category: 'First Class'
        }
      },
      naming : {
        top : false,
        getLabel : function (character, row, column) {
          return parseInt(seatNumbers[row-1][column - 1]);
        },
      },
      legend : {
        node : $('#legend'),
        items : self.seatItems()
      },
      click: function () {
        // A male and a female of different bookings never sit side by side in a row (checked here
        // only, not by the server); seats of the booking being made may mix genders.
        let seatNo = this.settings.label
        let beside = self.besideGenders(seatNo)
        let lock = beside.M && beside.F ? null : (beside.M ? 'M' : (beside.F ? 'F' : undefined))
        self.seatNotice(null)
        if (this.status() == 'available') {
          if (lock === null) {
            self.seatNotice(`Seat ${seatNo} can't be booked: seat ${beside.M} next to it has a male passenger and seat ${beside.F} a female passenger of another booking. Male and female passengers of different bookings can't sit side by side.`)
            return 'available';
          }

          if (lock == 'F') {
            self.seatNotice(`Seat ${seatNo} can't be booked for a male passenger: seat ${beside.F} next to it has a female passenger of another booking, so it has been selected for a female. Male and female passengers of different bookings can't sit side by side.`)
          }

          self.customerDetailsVisibility(false);
          let gender = lock == 'F' ? 'F' : 'M'
          let liTagId = `cart-item-${this.settings.id}`
          $('<li>'+this.data().category+' Seat # '+this.settings.label+': <b>'+this.data().price+' Rs</b></li>')
            .attr('id', liTagId)
            .data('seatId', this.settings.id)
            .appendTo(cart);

          counter.text(sc.find('selected').length + sc.find('doubleselected').length + 1);
          total.text(self.recalculateTotal(sc)+this.data().price);

          $(`<input type="hidden" name="booking[booked_seats][]" value="${this.settings.label}" id="seat-${this.settings.id}">`).appendTo($(`#${liTagId}`))
          $(`<input type="hidden" name="booking[seats_gender][]" value="${this.settings.label}${gender}" id="seat-${this.settings.id}M">`).appendTo($(`#${liTagId}`))

          // Male first; a seat only a female may take starts as female.
          return gender == 'F' ? 'doubleselected' : 'selected';
        }
        else if (this.status() == 'selected' && lock != 'M') {
          self.customerDetailsVisibility(false);
          $(`#seat-${this.settings.id}M`).val(`${this.settings.label}F`)
          return 'doubleselected';
        }
        else if (this.status() == 'selected' || this.status() == 'doubleselected') {
          // Female (or male on a seat only a male may take): clicked again, the seat is cleared.
          if (this.status() == 'selected' && lock == 'M') {
            self.seatNotice(`Seat ${seatNo} can't be booked for a female passenger: seat ${beside.M} next to it has a male passenger of another booking, so it has been deselected. Male and female passengers of different bookings can't sit side by side.`)
          }
          self.customerDetailsVisibility(false);
          counter.text((sc.find('selected').length + sc.find('doubleselected').length)-1);
          let totalAmount = self.recalculateTotal(sc) - this.data().price
          total.text(totalAmount > 0 ? totalAmount : 0);
          $('#cart-item-'+this.settings.id).remove();

          return 'available';
        }
        else if (this.status() == 'unavailable') {
          self.getCustomerDetails(this.settings.label);
          return 'unavailable';
        }
        else
          return this.style();
      }
    });

    // sc.get(['1_2', '4_1', '7_1', '7_2']).status('unavailable');
    sc.get(unavailableSeats).status('unavailable');
    this.markCounterSeats(sc, seatsMapping)
  }

  // Seat-chart ids ("row_column") of the Cash on Counter seats get their own colour.
  markCounterSeats(sc, seatsMapping) {
    let counterSeats = (this.counterseatsValue || []).map(seat => parseInt(seat))
    if (!counterSeats.length) return;

    let ids = []
    seatsMapping.forEach((row, rowIndex) => {
      row.forEach((seat, columnIndex) => {
        if (counterSeats.includes(parseInt(seat))) ids.push(`${rowIndex + 1}_${columnIndex + 1}`)
      })
    })
    if (ids.length) sc.get(ids).node().addClass('cash-on-counter-seat')
  }

  // { seat: [seats beside it] }: neighbouring cells of a row of the seat map, with no aisle or gap between them.
  buildSeatNeighbours(seatsMapping) {
    let neighbours = {}
    seatsMapping.forEach(row => {
      for (let i = 0; i < row.length - 1; i++) {
        let left = parseInt(row[i]), right = parseInt(row[i + 1])
        if (!left || !right) continue;

        (neighbours[left] = neighbours[left] || []).push(right);
        (neighbours[right] = neighbours[right] || []).push(left);
      }
    })
    return neighbours
  }

  // { M: a seat beside seatNo held by a male of another booking, F: likewise for a female } (either may be missing).
  besideGenders(seatNo) {
    let taken = {}
    ;(this.bookedgendersValue || []).forEach(entry => {
      let match = String(entry).trim().match(/^(\d+)\s*([MF])$/i)
      if (match) taken[parseInt(match[1])] = match[2].toUpperCase()
    })

    let beside = {}
    ;(this.seatNeighbours[parseInt(seatNo)] || []).forEach(other => {
      if (taken[other] && !beside[taken[other]]) beside[taken[other]] = other
    })
    return beside
  }

  // Shows why a seat click was refused or undone; null hides it.
  seatNotice(message) {
    if (!this.hasSeatNoticeTarget) return;

    this.seatNoticeTarget.textContent = message || '';
    this.seatNoticeTarget.classList.toggle('d-none', !message);
  }

  recalculateTotal(sc) {
    let total = 0;
    sc.find('selected').each(function () {
      total += this.data().price;
    });

    sc.find('doubleselected').each(function () {
      total += this.data().price;
    });

    return total;
  }

  busSeatsMapping(seatsMapping) {
    let mapping = new Array()
    let character = this.getBusTypeCharacter()
    let row_seats = this.busleftseatsValue + this.busrightseatsValue
    console.log("Row: ", parseInt(this.totalseatsValue / row_seats))
    for(let i = 0; i < seatsMapping.length; i++) {
      let row = ""
      for(let j = 0; j < 5; j++) {
        if(parseInt(seatsMapping[i][j]) == 0)
          row += "_"
        else if(this.bustypeValue == 'business' && parseInt(seatsMapping[i][j]) <= 9)
          row += character[0]
        else if(this.bustypeValue == 'business' && parseInt(seatsMapping[i][j]) > 9)
          row += character[1]
        else
          row += character[0] //for economical and luxury bus types
      }

      mapping.push(row)
    }

    return mapping;
  }

  getBusTypeCharacter() {
    if(this.bustypeValue == 'economical')
      return ['e'];
    else if(this.bustypeValue == 'luxury')
      return ['l'];
    else
      return ['b', 'e'];
  }

  seatItems() {
    let items = new Array()
    if(this.bustypeValue == 'economical')
      items.push(['e', 'available', 'Economy Class'])
    else if(this.bustypeValue == 'luxury')
      items.push(['l', 'available',   'Luxury Class'])
    else {
      items = items.concat([['e', 'available', 'Economy Class'], ['l', 'available', 'Luxury Class']])
    }

    items = items.concat([[ 'f', 'unavailable', 'Booked'], [ '', 'selected', 'Male' ], [ '', 'doubleselected', 'Female' ]])
    if (this.isAdminUserValue) items.push([ '', 'unavailable cash-on-counter-seat', 'Cash on Counter' ])
    return items;
  }

  getCustomerDetails(seat_no) {
    if (this.isAdminUserValue) {
      let url = this.seatDetailUrlValue + '&seat_no=' + seat_no;

      fetch(url)
        .then(response => response.json())
        .then(response => {
          if (response.booking) {
            this.customerDetailsVisibility(true);
            this.customerNameTarget.innerHTML = response.booking.traveler_name;
            this.customerCnicTarget.innerHTML = response.booking.traveler_cnic;
            this.customerPhoneTarget.innerHTML = response.booking.traveler_phone;
            this.customerSeatNoTarget.innerHTML = response.booking.seats_gender;
            this.customerAmountTarget.innerHTML = response.booking.price;
          } else {
            this.customerDetailsVisibility(false);
            this.customerNameTarget.innerHTML = '';
            this.customerCnicTarget.innerHTML = '';
            this.customerPhoneTarget.innerHTML = '';
            this.customerSeatNoTarget.innerHTML = '';
            this.customerAmountTarget.innerHTML = '';
          }
        })
        .catch(err => console.log(err));
    } else {
      // console.log("You are unauthorize to get customer details. Thank you!");
    }
  }

  customerDetailsVisibility(visible=false) {
    if (!this.hasCustomerAmountTarget) return;

    if(visible) {
      this.customerDetailsTarget.classList.remove('hide');
    } else {
      this.customerDetailsTarget.classList.add('hide');
    }
  }
}
